











































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { cloneDeep, isEqual } from 'lodash'
import { TriggeredAction } from '@/api/model/triggered-action'
import { availableReferralStatuses, TriggerType } from '@/api/types'

@Component
export default class CreateAutoActionFormStep2 extends Vue {
    @Prop({ required: true }) readonly value!: TriggeredAction
    editingValue: TriggeredAction = null

    @Watch('value', { immediate: true })
    onValueChanged() {
        this.editingValue = cloneDeep(this.value)
    }

    @Watch('editingValue.triggerType')
    @Watch('editingValue.changedFieldValue')
    onEditingValueChanged() {
        if (isEqual(this.editingValue, this.value)) {
            return
        }

        this.$emit('update:value', this.editingValue)
    }

    get triggerType(): string {
        let triggerType = this.editingValue.triggerType as string

        if (triggerType === 'change') {
            triggerType += '-' + this.editingValue.changedField
        }

        return triggerType
    }

    set triggerType(triggerType: string) {
        let changedField = null

        if (triggerType !== TriggerType.appointment) {
            [triggerType, changedField] = triggerType.split('-')
        }

        this.editingValue.triggerType = triggerType as TriggerType
        this.editingValue.changedField = changedField
    }

    get availableTriggerTypeOptions() {
        const options = [
            {
                label: this.$t(`forms.triggered_action_form.trigger_type_options.${TriggerType.change}-status`),
                value: TriggerType.change + '-status',
            },
            {
                label: this.$t(`forms.triggered_action_form.trigger_type_options.${TriggerType.appointment}`),
                value: TriggerType.appointment,
            },
        ]

        if (this.$currentCompany.pipelinesEnabled) {
            options.unshift({
                label: this.$t(`forms.triggered_action_form.trigger_type_options.${TriggerType.change}-phase`),
                value: TriggerType.change + '-phase',
            })
        }

        return options
    }

    get availableReferralPhaseOptions() {
        const phases = this.editingValue.referralPipeline?.phases || []

        return phases
            .map(phase => ({
                label: phase.name,
                value: phase.id,
            }))
    }

    get availableReferralStatusOptions() {
        return availableReferralStatuses(this.$currentCompany).map(status => ({
            label: this.$t('referral.phaseModelStatus.' + status),
            value: status,
        }))
    }

    get avatarHeaderText() {
        const values = {
            leads: '',
            pipeline: this.value.referralPipeline.name,
        }

        if (this.editingValue.referralOrigin === 'external') {
            values.leads = 'externe'
        } else if (this.editingValue.referralOrigin === 'internal') {
            values.leads = 'interne'
        } else  {
            values.leads = 'externe en interne'
        }

        return this.$t('virtualColleague.autoLead.avatarHeader.actionPipelineHeader', values)
    }
}
